/**
 * Case-insensitive containment filter shared by all search inputs.
 * Returns all items when the term is empty/whitespace; otherwise keeps items
 * where at least one selected string contains the term.
 */
export function filterBySearchTerm<T>(items: T[], searchTerm: string, ...selectors: ((item: T) => string | undefined)[]): T[] {
  const term = searchTerm.trim().toLowerCase();
  if (!term) {
    return items;
  }

  return items.filter((item) => selectors.some((selector) => selector(item)?.toLowerCase().includes(term)));
}
